import { render } from "./projectsetmodel.vue?vue&type=template&id=3c85d55e"
import script from "./projectsetmodel.vue?vue&type=script&lang=ts"
export * from "./projectsetmodel.vue?vue&type=script&lang=ts"
script.render = render

export default script